import { render } from "./SplitBill.vue?vue&type=template&id=3473ea51&scoped=true&ts=true"
import script from "./SplitBill.vue?vue&type=script&lang=ts"
export * from "./SplitBill.vue?vue&type=script&lang=ts"

import "./SplitBill.vue?vue&type=style&index=0&id=3473ea51&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3473ea51"]])

export default __exports__